import { PatientPhotoUrl } from "../components/EntityCard";

export function getGenderPhotoURL(gender: string | null) {
  if (gender === "M") {
    return PatientPhotoUrl.M;
  }

  return PatientPhotoUrl.F;
}
